module.exports = __webpack_public_path__ + "static/media/chalkboard-teacher-solid.78fdf712.svg";